<template>
  <v-main class="background fill-height">
    <v-row
      class="d-flex fill-height"
      no-gutters
    >
      <v-col
        cols="12"
        class="align-center d-flex"
      >
        <v-container>
          <div class="pa-7 pa-sm-12">
            <v-row>
              <v-col
                class="mx-auto"
                cols="12"
                lg="6"
              >
                <v-card
                  class="elevation-7 mx-auto pa-4 pt-7 rounded-lg text-center"
                  style="max-width: 460px; z-index: 1"
                >
                  <div v-if="ecoMemberPass">
                    <CheckMarkIcon class="mx-auto mb-4" />
                    <h2>
                      ECO Member Pass downloaded
                    </h2>
                  </div>
                  <div v-else>
                    <ErrorIcon
                      class="mx-auto mb-4 red--text"
                      width="52"
                    />
                    <h2>
                      Unknown ECO Member Pass
                    </h2>
                  </div>
                  <div
                    v-if="isLoadingScreenVisible"
                    key="loading-screen"
                    class="align-center d-flex flex-column"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="64"
                    />

                    <div class="my-4">
                      Loading, please wait ...
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-responsive
              height="150px"
              class="auth-footer d-md-block d-none"
              style="position: absolute; left: 0; bottom: 0; width: 100%; overflow: visible; "
            />
            <v-responsive
              class="auth-footer-end-tree d-md-block d-none"
              style="position: absolute; right: 50px; bottom: 30px; width: 122px"
            >
              <v-img
                src="../../images/butterfly.png"
              />
              <span class="text-caption disabled ml-2">v{{ appTag }}-{{ appHash }}</span>
            </v-responsive>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'

import { alertHandler } from '@/alertHandler'
import { openFileUrlInBrowser } from '@/utilities'

import { INTEGRATION_NAMESPACE } from '@/store/integrations'

import CheckMarkIcon from '@/components/Icons/CheckMark'
import ErrorIcon from '@/components/Icons/ErrorIcon'

export default {
  name: 'ECOMemberPasses',

  components: {
    CheckMarkIcon,
    ErrorIcon,
  },

  props: {
    passId: {
      type: String,
      required: true,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      appHash: process.env.VUE_APP_GIT_HASH,
      appTag: process.env.VUE_APP_GIT_TAG,
      ecoMemberPass: null,
      requestLoading: false,
    }
  },

  computed: {
    isLoadingScreenVisible () {
      return this.requestLoading
    },
  },

  async created () {
    this.requestLoading = true
    this.fetchECOMemberPass({
      passId: this.passId,
    }).then(data => {
      this.ecoMemberPass = data.eco_member_pass
      this.downloadAppleECOMberPass()
      this.displayAlert('success', 'Successfully loaded Pass')
    }).
      catch(error => {
        this.displayAlert('error', error.data.message)
      }).
      finally(_ => { this.requestLoading = false })
  },

  methods: {
    downloadAppleECOMberPass () {
      const filename = `eco_member_pass_${this.ecoMemberPass.ext_id}.pkpass`
      const url = `${window.location.origin}/api/admin/eco_member_pass/${this.ecoMemberPass.ext_id}/apple`

      try {
        openFileUrlInBrowser(url, 'application/vnd.apple.pkpass', true, filename)
      } catch (error) {
        this.displayAlert('error', 'There was an error loading file: ' + error)
      }
    },

    ...mapActions(INTEGRATION_NAMESPACE, [
      'fetchECOMemberPass',
    ]),
  },
}
</script>
